import axios, { AxiosRequestConfig } from 'axios';
import { API_BASEURL } from '../../Constants';

/**
 * Mutator using plain axios (no auth). Used for public API, login, register.
 */
export const axiosInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  return axios({
    ...config,
    baseURL: API_BASEURL ?? '',
    ...options,
  }).then(({ data }) => data);
};
